import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { AdminCatalogState } from "../types/index";
import { initialState } from "./initialState";

const getAdminCatalogState = (state: RootState) =>
  state.AdminCatalogState || initialState;

export const selectCatalogs = createSelector(
  [getAdminCatalogState],
  (adminCatalogState: AdminCatalogState) => adminCatalogState.catalogData
);

export const selectCatalogById = (id: number) =>
  createSelector([getAdminCatalogState], (adminCatalogState: AdminCatalogState) =>
    adminCatalogState.catalogData.find((row) => row.id === id)
  );

export const selectCatalogItems = createSelector(
  [getAdminCatalogState],
  (adminCatalogState: AdminCatalogState) => adminCatalogState.CatalogItems
);

export const selectIsLoading = createSelector(
  [getAdminCatalogState],
  (adminCatalogState: AdminCatalogState) => adminCatalogState.loading
);

export const selectIsAddModalOpen = createSelector(
  [getAdminCatalogState],
  (adminCatalogState: AdminCatalogState) => adminCatalogState.isAddModalOpen
);

export const selectAdminCatalogForm = createSelector(
  [getAdminCatalogState],
  (adminCatalogState: AdminCatalogState) => adminCatalogState.form
);

export const selectIsAddItemModalOpen = createSelector(
  [getAdminCatalogState],
  (adminCatalogState: AdminCatalogState) => adminCatalogState.isAddItemModalOpen
);

export const selectAdminCatalogItemForm = createSelector(
  [getAdminCatalogState],
  (adminCatalogState: AdminCatalogState) => adminCatalogState.itemForm
);
